export const getShopifySmartCollectionURL = (handle) =>
  `https://myarthaus.com/collections/${handle}`



// WEBPACK FOOTER //
// ./src/lib/uri.js